import React from "react";

const Svg1 = () => {
  return (
    <>
      <svg
        className="absolute inset-0 h-full w-full"
        width={343}
        height={388}
        viewBox="0 0 343 388"
        fill="none"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M-99 461.107L608.107-246l707.103 707.107-707.103 707.103L-99 461.107z"
          fill="url(#linear1)"
          fillOpacity=".1"
        />
        <defs>
          <linearGradient
            id="linear1"
            x1="254.553"
            y1="107.554"
            x2="961.66"
            y2="814.66"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#fff" stopOpacity={0} />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};

const Svg2 = () => {
  return (
    <>
      <svg
        className="absolute inset-0 h-full w-full"
        width={359}
        height={339}
        viewBox="0 0 359 339"
        fill="none"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M-161 382.107L546.107-325l707.103 707.107-707.103 707.103L-161 382.107z"
          fill="url(#linear2)"
          fillOpacity=".1"
        />
        <defs>
          <linearGradient
            id="linear2"
            x1="192.553"
            y1="28.553"
            x2="899.66"
            y2="735.66"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#fff" stopOpacity={0} />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};

const Svg3 = () => {
  return (
    <>
      <svg
        className="absolute inset-0 h-full w-full"
        width={160}
        height={678}
        viewBox="0 0 160 678"
        fill="none"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M-161 679.107L546.107-28l707.103 707.107-707.103 707.103L-161 679.107z"
          fill="url(#linear3)"
          fillOpacity=".1"
        />
        <defs>
          <linearGradient
            id="linear3"
            x1="192.553"
            y1="325.553"
            x2="899.66"
            y2="1032.66"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#fff" stopOpacity={0} />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};

export { Svg1, Svg2, Svg3 };
